module.exports = __webpack_public_path__ + "static/media/logo.10b5abae.png";